import { parsePhoneNumber } from 'libphonenumber-js'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { SvgEmail, SvgPhone } from '../icons'

export interface IBookingContactProviders {
  title?: string
  name?: string
  phone?: string
  email?: string
}

interface IBookingContactProvidersProps {
  services: IBookingContactProviders[]
}

const BookingContactServices = ({
  services,
}: IBookingContactProvidersProps) => {
  return (
    <div className={s.contact}>
      <div className={s.title}>
        <FormattedMessage
          id='ui.BookingContactServices'
          defaultMessage='Contactez vos prestataires'
        />
      </div>
      <ul>
        {services.map((service, index) => {
          const phoneNumber = service.phone
            ? parsePhoneNumber(service.phone, 'FR')?.formatInternational()
            : ''
          return (
            <li key={index}>
              <p className={s.title}>{service.title}</p>
              <p className={s.name}>{service.name}</p>
              {service.phone && (
                <div className={s.phone}>
                  <span className={s.icon}>
                    <SvgPhone />
                  </span>
                  <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
                </div>
              )}
              {service.email && (
                <div className={s.email}>
                  <span className={s.icon}>
                    <SvgEmail />
                  </span>
                  <a href={`mailto:${service.email}`}>{service.email}</a>
                </div>
              )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default BookingContactServices
